import React, { Component } from 'react'

const year = new Date().getFullYear();
export default class Footer extends Component {
  
  render() {
    return (
      <div>
        <footer class="footer">
        <div class="footer-text">
            <p>Copyright &copy; {year} by Curtrick Walton</p>
        </div>

        <div class="footer-iconTop">
            <a href='#Home' onClick={()=>{const anchor = document.querySelector('#home')
anchor.scrollIntoView({ behavior: 'smooth', block: 'center' })}}><i class='bx bx-chevron-up' ></i></a>
        </div>
        </footer>
      </div>
    )
  }
}
